<template lang="pug">
  #bio
    section.section
      .columns(style="max-width: 1024")
        Col#headImg(:m=5 :s=6 :xs=12)
          ProfileImg
        Col(:m=7 :s=6 :xs=12)
          .personCard
            transition(name="fade")
              .contentBlock(v-if="isPress[0]")
                .title.is-5 Hi, I'm Ryan, and my Chinese name is Yu-An Chen.
                .subtitle.is-6
                  span Graduate student at MHCI Lab (National Taiwan University),
                  br
                  span research interests include HCI, web development.
                  br
                  br
                  span I'm always passionate about learning new techniques and professional knowledge. I also occasionally write articles to share my development and travel experiences. See also my blog on Medium:
                  a(href="https://medium.com/@ryanC1993" target="_blank") medium.com/@ryanC1993
                  span .
                  br
                  br
                .menu-label Contact me:
                //- .title.is-6(style="margin-bottom: 5px") - Linkedin:
                //-   a(href="https://www.linkedin.com/in/ryanc1993/" target="_blank") Yu-An Chen
                .title.is-6 - Mail:
                  a(href="mailto:ryan149347@gmail.com") ryan149347@gmail.com
            transition(name="fade")
              .contentBlock(v-if="isPress[1]")
                .list(v-for="item in education")
                  span.menu-label {{item.duration}}
                  .title.is-5 {{item.name}}
                  .subtitle.is-6 {{item.description}}
            transition(name="fade")
              .contentBlock(v-if="isPress[2]")
                .list(v-for="item in experience")
                  span.menu-label {{item.duration}}
                  .title.is-5 {{item.name}}
                  .subtitle.is-6(v-html="item.description")
            .options
              .btn(:class="{ active: isPress[0]}" @click="show(0)") ABOUT
              .btn(:class="{ active: isPress[1]}" @click="show(1)") EDUCATION
              .btn(:class="{ active: isPress[2]}" @click="show(2)") EXPERIENCE
</template>

<script>

import ProfileImg from '@/components/ProfileImg'
import Col from '@/components/Col'
export default {
  name: 'Bio',
  components: {
    ProfileImg,
    Col
  },
  data () {
    return {
      isPress: [true, false, false],
      education: [
        {'name': 'National Taiwan University', 'duration': ' SEPT.2016 - JUL.2018', 'description': 'M.S. in Computer Science and Information Engineering. (Advisor: Mike Y. Chen)'},
        {'name': 'National Taipei University', 'duration': ' SEPT.2012 - JUN.2016', 'description': 'B.S. in Computer Science and Information Engineering.'}],
      experience: [
        {'name': 'PayPay', 'duration': 'APR.2023 - PRESENT', 'description': 'Software engineer.'},
        {'name': 'Yahoo!', 'duration': 'AUG.2021 - APR.2022', 'description': 'Senior Software engineer.'},
        {'name': 'Yahoo!', 'duration': 'NOV.2018 - JUL.2021', 'description': 'Software engineer.'}
        // {'name': 'Tripnotice.com', 'duration': 'AUG.2017 - MAR.2018', 'description': 'Front-end intern. Build city guide page by React.js and GraphQL. See <a href="https://tripnotice.com/guide" target="_blank" style="font-weight:bold;font-style:italic">Tripnotice.com/guide</a>.'},
        // {'name': 'Ubitus', 'duration': 'AUG.2016 - JAN.2017', 'description': 'VR/AR intern. Developed experimental demo apps by Unity to evaluate latency caused by network.'}
      ]
    }
  },
  methods: {
    show (index) {
      this.isPress = this.isPress.map(el => false)
      this.isPress[index] = true
    }
  }
}
</script>

<style lang="sass" scoped>

.fade-enter-active
  animation: show .5s 1

@keyframes show
  0%
    opacity: 0
  100%
    opacity: 1

section.section
  padding: 0 2.5rem

#placeholder
  z-index: 1030
  top: 30px

.columns
  margin: 0 auto
  max-width: 1344px
  .column
    height: 600px
    .personCard
      padding: 0 15px
      width: 100%
      height: 100%
      position: relative
      .contentBlock
        position: absolute
        width: 80%
        left: 50%
        top: 50%
        transform: translate(-50%, -50%)
        a
          font-weight: bold
          color: #666
          transition: .5s
          padding-left: 6px
          &:hover
            color: #146eb4
        .list
          padding-bottom: 30px
          position: relative
          .title, .subtitle
            border-left: solid 1px #222
            padding-left: 20px
          span
            padding-left: 10px
          span::before
            content: ''
            display: block
            position: absolute
            left: -4px
            top: 10px
            width: 8px
            height: 8px
            background-color: #222
      .options
        display: flex
        align-items: flex-end
        position: absolute
        bottom: -12px
        right: 0
        width: 90%
        .btn
          cursor: pointer
          background-color: rgba(208, 206, 204, 0.32)
          color: #222
          padding: 1.2rem 0.2rem
          outline: 0
          max-width: 15rem
          width: 33.3%
          text-align: center
          letter-spacing: .1rem
          font-size: .7em
          transition: .25s
          &:hover
            background-color: #3b3e45
            color: white
        .active
          background-color: #3b3e45
          color: white
          font-weight: 700
          padding-top: 1.5rem
          padding-bottom: 1.5rem
          margin-bottom: -0.3rem
          box-shadow: 0 6px 0 -2px rgba(#222, 0.5)
          transition: .25s

@media screen and (max-width: 436px)
  #headImg
    display: none
  section.section
    padding: 0 0em
  .columns
    .column
      min-height: 400px
      padding-left: 0
      padding-right: 0
      .personCard
        .options
          width: 100%
          bottom: inherit
          top: -12px
          .active
            padding: 1.2rem 0.2rem
            margin-bottom: 0rem

</style>



// WEBPACK FOOTER //
// src/section/Bio.vue